<button
        *ngIf="!link && !url && !disabled"
        [id]="id"
        (click)="handleClick($event)"
        class="primary-btn {{className}} {{load ? 'activeLoading' : ''}}"
        [style]="style">
    <i *ngIf="icon" class="fas {{icon}}"></i>
    {{text}}
    <span class="load loading"></span>
</button>

<a
        *ngIf="link && !url && !disabled"
        [id]="id"
        (click)='handleLinkClick()'
        class="primary-btn {{className}} {{load ? 'activeLoading' : ''}}">
    <i *ngIf="icon" class="fas {{icon}}"></i>
    {{text}}
</a>

<a
        *ngIf="!link && url && !disabled"
        [id]="id"
        [href]="[url]"
        target="_blank"
        class="primary-btn {{className}} {{load ? 'activeLoading' : ''}}">
    <i *ngIf="icon" class="fas {{icon}}"></i>
    {{text}}
</a>